<script setup lang="ts">
import DOMPurify from 'isomorphic-dompurify'
import { marked } from 'marked'

interface Props {
  content: string
}

const props = defineProps<Props>()

const content = computed(() => {
  return DOMPurify.sanitize(marked.parse(props.content))
})
</script>

<template>
  <div class="md-view" v-html="content" />
</template>
